import { RAG } from 'features/dashboard/charts/scoreColour'

export const STATUS_META = {
  pending: { label: 'Waiting for a decision', short: 'Waiting', rag: RAG.medium, help: 'The people who decide for this document have not decided yet. That is usually the organisation\'s Super Admins or a nominated approver, or the person who uploaded it.' },
  approved: { label: 'Approved', short: 'Approved', rag: RAG.low, help: 'The document has been shared with the person who asked. Only that one document.' },
  refused: { label: 'Refused', short: 'Refused', rag: RAG.critical, help: 'The request was turned down. The person can ask again after 7 days.' },
  withdrawn: { label: 'Withdrawn', short: 'Withdrawn', rag: RAG.none, help: 'The person who asked cancelled the request.' },
}

export const statusMeta = status => STATUS_META[status] || STATUS_META.pending

export const SKIP_REASON = {
  already_has_access: 'you can already open it',
  already_requested: 'you have already asked',
  recently_refused: 'it was refused in the last 7 days',
  not_found: 'it could not be found',
}

export const APPROVE_EXPLAINER = 'Approving shares this one document with this one person. Nothing else is shared, and you can stop sharing it later from the document\'s sharing settings.'

export const APPROVER_EXPLAINER = 'Some requests come to you because your organisation chose you to approve them, or because you are one of its Super Admins.'

export const SELF_GRANT_HELP = 'You need to be able to open the document before you approve it. This is recorded in its access history.'

export const DECIDE_REASON_MESSAGE = {
  not_pending: 'This request has already been dealt with.',
  not_allowed: 'You are not allowed to decide this request.',
  needs_access: 'You need to be able to open this document before you decide. Use "Give myself access" first.',
  self: "You can't decide your own request.",
}

export const WHO_DECIDES = 'Each request goes to the people who decide for that document: usually the organisation\'s Super Admins or a nominated approver, or the person who uploaded it.'

export const LOCKED_EXPLAINER = 'You can see that this document exists, but you need permission to open it from the people who decide for it: usually the organisation\'s Super Admins or a nominated approver, or the person who uploaded it.'

export const SUCCESSION_EXPLAINER = 'This document was added before the Building Passport changed hands, so it still belongs to the previous owner\'s organisation.'

export const formatDate = iso => {
  if (!iso) return ''
  const d = new Date(iso)
  return Number.isNaN(d.getTime()) ? '' : d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })
}

export const errorMessage = (err, fallback = 'That did not work. Please try again.') => {
  const data = err?.response?.data
  if (data?.errors) return Object.values(data.errors).flat()[0] || fallback
  return data?.message || fallback
}
